import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NestApiProvider } from '../nest-api';
import { Paginate } from '../../../model/chat/paginate';
import { IListGroup, ILookUp } from '../nest-model/access-authorization';
import { Observable } from 'rxjs/Observable';
import { Employee } from '../../../model/employee';
import { RequestPaging } from '../gd-all-in-one/dto/claim.dto';

/*
  Generated class for the AccessManagementProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

@Injectable()
export class AccessAuthorizationApiProvider {

  module: string = 'accessAuthorization';
  constructor(
    public http: HttpClient,
    public nestApi: NestApiProvider
  ) {
    console.log('Hello AccessAuthorizationApiProvider Provider');
  }

  listing(formData) {
    const method: string = "POST";
    const model: string = "accessAuthorization";
    const func: string = "listing";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<Paginate<IListGroup>>(method, url, params, urlParams, body, contentType);
  }

  listingEmp(payload: { fullName: string }, queryParams: RequestPaging) {
    const method: string = "POST";
    const model: string = "accessAuthorization";
    const func: string = "listingEmp";
    const params: any = payload;
    const urlParams: any = queryParams;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<Paginate<IListGroup>>(method, url, params, urlParams, body, contentType);
  }

  filterMemberAvailable(formData, queryParams) {
    const method: string = "POST";
    const model: string = "accessAuthorization";
    const func: string = "filterMemberAvailable";
    const params: any = formData;
    const urlParams: any = queryParams;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<Paginate<Employee>>(method, url, params, urlParams, body, contentType);
  }

  filterMemberList(formData, queryParams) {
    const method: string = "POST";
    const model: string = "accessAuthorization";
    const func: string = "filterMemberList";
    const params: any = formData;
    const urlParams: any = queryParams;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<Paginate<Employee>>(method, url, params, urlParams, body, contentType);
  }

  accessList(formData) {
    const method: string = "POST";
    const model: string = "accessAuthorization";
    const func: string = "accessList";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<Paginate<any>>(method, url, params, urlParams, body, contentType);
  }

  menuAccessTree(formData) {
    const method: string = "POST";
    const model: string = "accessAuthorization";
    const func: string = "menuAccessTree";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request(method, url, params, urlParams, body, contentType);
  }

  userAccessTree(formData: { userId: any }) {
    const method: string = "POST";
    const model: string = "accessAuthorization";
    const func: string = "userAccessTree";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request(method, url, params, urlParams, body, contentType);
  }

  searchAccessTree(formData: { text: string }) {
    const method: string = "POST";
    const model: string = "accessAuthorization";
    const func: string = "searchAccessTree";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request(method, url, params, urlParams, body, contentType);
  }

  lookupStatus(formData?: any) {
    const method: string = "GET";
    const model: string = "lookup";
    const func: string = "status";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<ILookUp>(method, url, params, urlParams, body, contentType);
  }

  lookupGroupType(formData?: any) {
    const method: string = "GET";
    const model: string = "lookup";
    const func: string = "groupType";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<ILookUp>(method, url, params, urlParams, body, contentType);
  }

  lookupMode(formData?: any) {
    const method: string = "GET";
    const model: string = "lookup";
    const func: string = "mode";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<ILookUp>(method, url, params, urlParams, body, contentType);
  }

  getDynamicColumn(formData?: any) {
    const method: string = "GET";
    const model: string = "accessAuthorization";
    const func: string = "getDynamicColumn";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<ILookUp>(method, url, params, urlParams, body, contentType);
  }

  saveGroup(formData): Observable<any> {
    const method: string = "POST";
    const model: string = "accessAuthorization";
    const func: string = "save";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request(method, url, params, urlParams, body, contentType);
  }

  saveGroupMember(formData): Observable<any> {
    const method: string = "POST";
    const model: string = "accessAuthorization";
    const func: string = "saveGroupMember";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request(method, url, params, urlParams, body, contentType);
  }

  saveAccess(formData): Observable<any> {
    const method: string = "POST";
    const model: string = "accessAuthorization";
    const func: string = "saveAccess";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request(method, url, params, urlParams, body, contentType);
  }

  deleteGroup(formData): Observable<any> {
    const method: string = "POST";
    const model: string = "accessAuthorization";
    const func: string = "delete";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request(method, url, params, urlParams, body, contentType);
  }

  filterGroupList(formData: { userId: number, name: string }): Observable<any> {
    const method: string = "POST";
    const func: string = "filterGroupList";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, this.module, func, params, urlParams, this.module);
    return this.nestApi.request(method, url, params, urlParams, body, contentType);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/access-management/access-authorization-api.ts